var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sca-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicial,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicial", $$v);
      },
      expression: "form.filters.dataInicial"
    }
  }), _c('sca-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFinal,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFinal", $$v);
      },
      expression: "form.filters.dataFinal"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Código de Habilidade",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.codigo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "codigo", $$v);
      },
      expression: "form.filters.codigo"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 2,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Prática de Linguagem",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarRelatorios();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listRelatorios,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "sort-desc": true,
      "show-expand": "",
      "expanded": _vm.expanded
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref2) {
        var headers = _ref2.headers,
          item = _ref2.item;
        return [_c('td', {
          staticClass: "blue-grey lighten-5",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.codigoList, function (codigo, i) {
          return _c('v-chip', {
            key: i
          }, [_vm._v(" " + _vm._s(codigo.nome) + " ")]);
        }), 1)], 1)];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.dataAcao`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarDataHora(item.dataAcao)) + " ")];
      }
    }, {
      key: `item.acao`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.acao) + " ")];
      }
    }], null, true)
  }), _vm.form.lists.listRelatorios.length ? _c('sca-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": function ($event) {
        return _vm.baixarRelatorio('PDF');
      },
      "cancel": function ($event) {
        return _vm.baixarRelatorio('CSV');
      }
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }